








import Vue from 'vue';
import MembersLayout from "@/layouts/Members.layout.vue";

export default Vue.extend({
    name: 'MembersContainer',
    components: {
      // Incluimos el layout (master page) que utilizará este módulo
      MembersLayout,
    },
})
